module.exports = __webpack_public_path__ + "static/media/mum-kids05.57aed558.png";